<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="red" dark v-bind="attrs" v-on="on">
        备注提醒
      </v-btn>
    </template>
    <v-container class="px-3 my-container">
      <!-- <v-card-title class="headline">编辑</v-card-title> -->

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>备注提醒</h1></v-card-title>

        <!-- ['10001','潘金云','330421196904152048','40','缪家村','西窑洞浜１３号'], -->
        <!-- <v-divider class="mx-4 my-10"></v-divider> -->
        <v-alert
          :value="alert"
          color="red"
          dark
          border="top"
          icon="mdi-bell"
          transition="scale-transition"
        >
          {{ alert_text }}
        </v-alert>
        
        <v-row>

          <v-text-field
            v-model="customer.note"
            color="yellow darken-3"
            label="备注"
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          
        </v-row>
        <v-row>

        <v-textarea
          v-model="customer.remind"
          color="yellow darken-3"
          label="提醒"
          required
          class="mx-6"
          style="width:400px"
        ></v-textarea>

</v-row>
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelAddDialog">取消</v-btn>
          <v-btn color="primary" @click="updateCustomer">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
</template>

<script>
import { updateCustomerById } from "@/api/customers";
// import { ModelListSelect } from "vue-search-select";
export default {
  name: "AddCompanyDialog",
  components: {},

  data: () => ({
    rules: {
        required: value => !!value || 'Field is required',
      },
    objectItem: {},
    stringItem: "",
    dialog: false,
    customer: {
      remind: "",
      note:""
    },
    alert: false,
    alert_text: "",
  }),
  watch:{
    'dialog': {
      handler(newVal) {
        // console.log(this.$parent.customer, 111)
        this.customer = this.$parent.customer
      },
      deep: true
    }
  },
  methods: {
    updateCustomer() {
      const customersData = this.customer;
      // if (customersData['remind'] == ''){
      //   this.alert_text = "请输入提醒内容！";
      //   this.alert = true;
      //   return false;
      // }
     
      console.log(customersData);
      updateCustomerById(customersData.id, customersData).then(response => {
        this.dialog = false;
        this.temp = {};
        this.$parent.getList();
      });
    
    },

    cancelAddDialog() {
      this.dialog = false;
      this.customers = {};
    }
  }
};
</script>

<style scoped>
.my-container {
  background-color: rgba(90, 90, 90, 0.9);
}
</style>
